import { InjectionToken, Injectable, Optional, Inject, ɵɵdefineInjectable, ɵɵinject, Pipe, NgModule } from '@angular/core';
import { formatDate } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { _log } from 'b2c-ui/core';

/**
 * @fileoverview added by tsickle
 * Generated from: i18n.token.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const B2C_LIB_I18N = new InjectionToken('b2c-lib-i18n');

/**
 * @fileoverview added by tsickle
 * Generated from: i18n.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const B2cLanguage = {
    EN: "en",
    SIMPLIFIED_CN: "zh-Hans",
    TRADITIONAL_CN: "zh-Hant",
    TRADITIONAL_CN_HK: "zh-Hant-HK",
};
/** @enum {string} */
const B2cStandardDateFormat = {
    EN: "dd MMM yyyy",
    CN: "yyyyMMdd",
};

/**
 * @fileoverview added by tsickle
 * Generated from: i18n-tr-key.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// ng-packager does not support i18n support in Angular Library.
// GitHub issue: https://github.com/ng-packagr/ng-packagr/issues/695
class I18nTransKey {
}
I18nTransKey.LOGIN_TO_YOUR_ACCOUNT = 'LOGIN_TO_YOUR_ACCOUNT';
I18nTransKey.LOGIN_NAME = 'LOGIN_NAME';
I18nTransKey.SIGN_UP = 'SIGN_UP';
I18nTransKey.OPEN_NEW_ACCOUNT = 'OPEN_NEW_ACCOUNT';
I18nTransKey.PASSWORD = 'PASSWORD';
I18nTransKey.REMEMBER_MY_USERNAME = 'REMEMBER_MY_USERNAME';
I18nTransKey.LOGIN = 'LOGIN';
I18nTransKey.ID_CANNOT_BE_BLANK = 'ID_CANNOT_BE_BLANK';
I18nTransKey.PASSWORD_CANNOT_BE_BLANK = 'PASSWORD_CANNOT_BE_BLANK';
I18nTransKey.FORGOT_USER_ID = 'FORGOT_USER_ID';
I18nTransKey.FORGOT_PASSWORD = 'FORGOT_PASSWORD';
I18nTransKey.SIGN_UP_NOW = 'SIGN_UP_NOW';
I18nTransKey.REMEMBER_ME = 'REMEMBER_ME';
I18nTransKey.FOREIGN_CURRENCIES_UNITS = 'FOREIGN_CURRENCIES_UNITS';
I18nTransKey.CHANGES = 'CHANGES';
I18nTransKey.CURRENCY_AUD = 'CURRENCY_AUD';
I18nTransKey.CURRENCY_MYR = 'CURRENCY_MYR';
I18nTransKey.CURRENCY_USD = 'CURRENCY_USD';
I18nTransKey.CURRENCY_GBP = 'CURRENCY_GBP';
I18nTransKey.CURRENCY_CNY = 'CURRENCY_CNY';
I18nTransKey.CURRENCY_EUR = 'CURRENCY_EUR';
I18nTransKey.SELECT_YOUR_COUNTRY = 'SELECT_YOUR_COUNTRY';
I18nTransKey.FILTER = 'FILTER';
I18nTransKey.CLEAR = 'CLEAR';
I18nTransKey.SELECT_GEOGRAPHICAL_SECTOR = 'SELECT_GEOGRAPHICAL_SECTOR';
I18nTransKey.COUNTRY_MYR = 'COUNTRY_MYR';
I18nTransKey.COUNTRY_AUD = 'COUNTRY_AUD';
I18nTransKey.COUNTRY_EUR = 'COUNTRY_EUR';
I18nTransKey.COUNTRY_USD = 'COUNTRY_USD';
I18nTransKey.COUNTRY_CNY = 'COUNTRY_CNY';
I18nTransKey.COUNTRY_GBP = 'COUNTRY_GBP';
I18nTransKey.COUNTRY_SGD = 'COUNTRY_SGD';
I18nTransKey.COUNTRY_HK = 'COUNTRY_HK';
I18nTransKey.COUNTRY_IND = 'COUNTRY_IND';
I18nTransKey.DONE = 'DONE';
I18nTransKey.SHARE = 'SHARE';
I18nTransKey.CANCEL = 'CANCEL';
I18nTransKey.CLEAR_SELECTED_FILTER = 'CLEAR_SELECTED_FILTER';
I18nTransKey.TRANSACT = 'TRANSACT';
I18nTransKey.CURRENT_COUNTRY = 'CURRENT_COUNTRY';
I18nTransKey.SEARCH_PLACEHOLDER = 'SEARCH_PLACEHOLDER';
I18nTransKey.SEARCH_NO_RESULT = 'SEARCH_NO_RESULT';
I18nTransKey.SEARCHING = 'SEARCHING';
I18nTransKey.SAFE_AREA_MESSAGE_1 = 'SAFE_AREA_MESSAGE_1';
I18nTransKey.DESKTOP_VIEW = 'DESKTOP_VIEW';
I18nTransKey.MOBILE_VIEW = 'MOBILE_VIEW';
I18nTransKey.SAFE_AREA_MESSAGE_2 = 'SAFE_AREA_MESSAGE_2';
I18nTransKey.CONTINUE_IN = 'CONTINUE_IN';
I18nTransKey.PROCEED_TO = 'PROCEED_TO';
I18nTransKey.WEBSITE = 'WEBSITE';
I18nTransKey.MOBILE_WEB = 'MOBILE_WEB';
I18nTransKey.SECURITY_TIPS = 'SECURITY_TIPS';
if (false) {
    /** @type {?} */
    I18nTransKey.LOGIN_TO_YOUR_ACCOUNT;
    /** @type {?} */
    I18nTransKey.LOGIN_NAME;
    /** @type {?} */
    I18nTransKey.SIGN_UP;
    /** @type {?} */
    I18nTransKey.OPEN_NEW_ACCOUNT;
    /** @type {?} */
    I18nTransKey.PASSWORD;
    /** @type {?} */
    I18nTransKey.REMEMBER_MY_USERNAME;
    /** @type {?} */
    I18nTransKey.LOGIN;
    /** @type {?} */
    I18nTransKey.ID_CANNOT_BE_BLANK;
    /** @type {?} */
    I18nTransKey.PASSWORD_CANNOT_BE_BLANK;
    /** @type {?} */
    I18nTransKey.FORGOT_USER_ID;
    /** @type {?} */
    I18nTransKey.FORGOT_PASSWORD;
    /** @type {?} */
    I18nTransKey.SIGN_UP_NOW;
    /** @type {?} */
    I18nTransKey.REMEMBER_ME;
    /** @type {?} */
    I18nTransKey.FOREIGN_CURRENCIES_UNITS;
    /** @type {?} */
    I18nTransKey.CHANGES;
    /** @type {?} */
    I18nTransKey.CURRENCY_AUD;
    /** @type {?} */
    I18nTransKey.CURRENCY_MYR;
    /** @type {?} */
    I18nTransKey.CURRENCY_USD;
    /** @type {?} */
    I18nTransKey.CURRENCY_GBP;
    /** @type {?} */
    I18nTransKey.CURRENCY_CNY;
    /** @type {?} */
    I18nTransKey.CURRENCY_EUR;
    /** @type {?} */
    I18nTransKey.SELECT_YOUR_COUNTRY;
    /** @type {?} */
    I18nTransKey.FILTER;
    /** @type {?} */
    I18nTransKey.CLEAR;
    /** @type {?} */
    I18nTransKey.SELECT_GEOGRAPHICAL_SECTOR;
    /** @type {?} */
    I18nTransKey.COUNTRY_MYR;
    /** @type {?} */
    I18nTransKey.COUNTRY_AUD;
    /** @type {?} */
    I18nTransKey.COUNTRY_EUR;
    /** @type {?} */
    I18nTransKey.COUNTRY_USD;
    /** @type {?} */
    I18nTransKey.COUNTRY_CNY;
    /** @type {?} */
    I18nTransKey.COUNTRY_GBP;
    /** @type {?} */
    I18nTransKey.COUNTRY_SGD;
    /** @type {?} */
    I18nTransKey.COUNTRY_HK;
    /** @type {?} */
    I18nTransKey.COUNTRY_IND;
    /** @type {?} */
    I18nTransKey.DONE;
    /** @type {?} */
    I18nTransKey.SHARE;
    /** @type {?} */
    I18nTransKey.CANCEL;
    /** @type {?} */
    I18nTransKey.CLEAR_SELECTED_FILTER;
    /** @type {?} */
    I18nTransKey.TRANSACT;
    /** @type {?} */
    I18nTransKey.CURRENT_COUNTRY;
    /** @type {?} */
    I18nTransKey.SEARCH_PLACEHOLDER;
    /** @type {?} */
    I18nTransKey.SEARCH_NO_RESULT;
    /** @type {?} */
    I18nTransKey.SEARCHING;
    /** @type {?} */
    I18nTransKey.SAFE_AREA_MESSAGE_1;
    /** @type {?} */
    I18nTransKey.DESKTOP_VIEW;
    /** @type {?} */
    I18nTransKey.MOBILE_VIEW;
    /** @type {?} */
    I18nTransKey.SAFE_AREA_MESSAGE_2;
    /** @type {?} */
    I18nTransKey.CONTINUE_IN;
    /** @type {?} */
    I18nTransKey.PROCEED_TO;
    /** @type {?} */
    I18nTransKey.WEBSITE;
    /** @type {?} */
    I18nTransKey.MOBILE_WEB;
    /** @type {?} */
    I18nTransKey.SECURITY_TIPS;
}

/**
 * @fileoverview added by tsickle
 * Generated from: locale/en-us.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var en_US = {
    locale: B2cLanguage.EN,
    dateFormat: B2cStandardDateFormat.EN,
    lang: {
        [I18nTransKey.LOGIN_TO_YOUR_ACCOUNT]: 'Login To Your Account',
        [I18nTransKey.LOGIN_NAME]: 'User ID',
        [I18nTransKey.PASSWORD]: 'Password',
        [I18nTransKey.REMEMBER_MY_USERNAME]: 'Remember My User ID',
        [I18nTransKey.LOGIN]: 'Login',
        [I18nTransKey.ID_CANNOT_BE_BLANK]: 'ID cannot be blank.',
        [I18nTransKey.PASSWORD_CANNOT_BE_BLANK]: 'Password cannot be blank.',
        [I18nTransKey.FORGOT_USER_ID]: 'Forgot User ID?',
        [I18nTransKey.FORGOT_PASSWORD]: 'Forgot Password?',
        [I18nTransKey.SIGN_UP_NOW]: 'Sign Up Now',
        [I18nTransKey.OPEN_NEW_ACCOUNT]: 'Open A New Account',
        [I18nTransKey.FOREIGN_CURRENCIES_UNITS]: 'Foreign Currencies Units',
        [I18nTransKey.CHANGES]: 'Changes',
        [I18nTransKey.CURRENCY_AUD]: '1 Australlian Dollar',
        [I18nTransKey.CURRENCY_CNY]: '1 Chinese Renminbi',
        [I18nTransKey.CURRENCY_EUR]: '1 EURO',
        [I18nTransKey.CURRENCY_GBP]: '1 U.K. Pound',
        [I18nTransKey.CURRENCY_MYR]: '1 Malaysian Ringgit',
        [I18nTransKey.CURRENCY_USD]: '1 U.S. Dollar',
        [I18nTransKey.SELECT_YOUR_COUNTRY]: 'SELECT YOUR COUNTRY/REGION',
        [I18nTransKey.FILTER]: 'Filter',
        [I18nTransKey.CLEAR]: 'Clear',
        [I18nTransKey.SELECT_GEOGRAPHICAL_SECTOR]: 'Select Geographical Sector',
        [I18nTransKey.COUNTRY_AUD]: 'Australia',
        [I18nTransKey.COUNTRY_MYR]: 'Malaysia',
        [I18nTransKey.COUNTRY_USD]: 'United States',
        [I18nTransKey.COUNTRY_CNY]: 'China',
        [I18nTransKey.COUNTRY_GBP]: 'United Kingdom',
        [I18nTransKey.COUNTRY_EUR]: 'Europe',
        [I18nTransKey.COUNTRY_IND]: 'India',
        [I18nTransKey.COUNTRY_SGD]: 'Singapore',
        [I18nTransKey.COUNTRY_HK]: 'Hong Kong',
        [I18nTransKey.DONE]: 'Done',
        [I18nTransKey.SHARE]: 'Share',
        [I18nTransKey.CANCEL]: 'Cancel',
        [I18nTransKey.CLEAR_SELECTED_FILTER]: 'Clear Selected Filter',
        [I18nTransKey.TRANSACT]: 'Transact',
        [I18nTransKey.SIGN_UP]: 'Sign Up Now',
        [I18nTransKey.CURRENT_COUNTRY]: 'Current Country/Region',
        [I18nTransKey.SEARCH_PLACEHOLDER]: 'What are you looking for?',
        [I18nTransKey.SEARCH_NO_RESULT]: 'No results found',
        [I18nTransKey.SEARCHING]: 'Searching',
        [I18nTransKey.SAFE_AREA_MESSAGE_1]: 'For the best viewing experience, please refresh your browser to access ',
        [I18nTransKey.DESKTOP_VIEW]: 'Desktop View.',
        [I18nTransKey.MOBILE_VIEW]: 'Mobile View.',
        [I18nTransKey.SAFE_AREA_MESSAGE_2]: 'Changes that you made may not be saved.',
        [I18nTransKey.CONTINUE_IN]: 'Continue In ',
        [I18nTransKey.PROCEED_TO]: 'Proceed To ',
        [I18nTransKey.WEBSITE]: 'Website',
        [I18nTransKey.MOBILE_WEB]: 'Mobile Web',
        [I18nTransKey.SECURITY_TIPS]: 'Tips to Online Security'
    }
};

/**
 * @fileoverview added by tsickle
 * Generated from: i18n.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class I18nService {
    /**
     * @param {?} locale
     */
    constructor(locale) {
        this.englishLocale = en_US;
        this.localeSubject = new BehaviorSubject(this.activeLocale);
        this.setLocale(locale || en_US);
    }
    /**
     * @return {?}
     */
    get localeChange() {
        return this.localeSubject.asObservable();
    }
    /**
     * @return {?}
     */
    get locale() {
        return Object.assign({}, this.activeLocale);
    }
    /**
     * @param {?} newLocale
     * @return {?}
     */
    setLocale(newLocale) {
        if (this.activeLocale && newLocale.locale === this.activeLocale.locale) {
            return;
        }
        this.activeLocale = newLocale;
        this.localeSubject.next(newLocale);
        _log('Setting Locale: ', this.activeLocale);
        return this.activeLocale;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    translate(key) {
        return this.activeLocale.lang[key] || this.englishLocale.lang[key] || '';
    }
}
I18nService.ɵfac = function I18nService_Factory(t) { return new (t || I18nService)(ɵngcc0.ɵɵinject(B2C_LIB_I18N, 8)); };
I18nService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: I18nService, factory: I18nService.ɵfac, providedIn: 'root' });
/** @nocollapse */
I18nService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [B2C_LIB_I18N,] }] }
];
/** @nocollapse */ I18nService.ngInjectableDef = ɵɵdefineInjectable({ factory: function I18nService_Factory() { return new I18nService(ɵɵinject(B2C_LIB_I18N, 8)); }, token: I18nService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(I18nService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [B2C_LIB_I18N]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    I18nService.prototype.activeLocale;
    /**
     * @type {?}
     * @private
     */
    I18nService.prototype.englishLocale;
    /**
     * @type {?}
     * @private
     */
    I18nService.prototype.localeSubject;
}

/**
 * @fileoverview added by tsickle
 * Generated from: standard-date.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StandardDatePipe {
    /**
     * @param {?} i18nService
     */
    constructor(i18nService) {
        this.i18nService = i18nService;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        const { dateFormat, locale } = this.i18nService.locale;
        return formatDate(value, dateFormat, locale);
    }
}
StandardDatePipe.ɵfac = function StandardDatePipe_Factory(t) { return new (t || StandardDatePipe)(ɵngcc0.ɵɵdirectiveInject(I18nService)); };
StandardDatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "sdate", type: StandardDatePipe, pure: true });
/** @nocollapse */
StandardDatePipe.ctorParameters = () => [
    { type: I18nService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StandardDatePipe, [{
        type: Pipe,
        args: [{
                name: 'sdate'
            }]
    }], function () { return [{ type: I18nService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    StandardDatePipe.prototype.i18nService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-lib-i18n.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CI18nPipe {
    /**
     * @param {?} i18nService
     */
    constructor(i18nService) {
        this.i18nService = i18nService;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    transform(key) {
        return this.i18nService.translate(key);
    }
}
B2CI18nPipe.ɵfac = function B2CI18nPipe_Factory(t) { return new (t || B2CI18nPipe)(ɵngcc0.ɵɵdirectiveInject(I18nService)); };
B2CI18nPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "b2cI18n", type: B2CI18nPipe, pure: true });
/** @nocollapse */
B2CI18nPipe.ctorParameters = () => [
    { type: I18nService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CI18nPipe, [{
        type: Pipe,
        args: [{
                name: 'b2cI18n'
            }]
    }], function () { return [{ type: I18nService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CI18nPipe.prototype.i18nService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: i18n.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moduleExports = [StandardDatePipe, B2CI18nPipe];
class I18nModule {
}
I18nModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: I18nModule });
I18nModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function I18nModule_Factory(t) { return new (t || I18nModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(I18nModule, { declarations: [StandardDatePipe,
        B2CI18nPipe], exports: [StandardDatePipe,
        B2CI18nPipe] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(I18nModule, [{
        type: NgModule,
        args: [{
                declarations: [...moduleExports],
                exports: [...moduleExports]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: i18n-token.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function B2cI18nInterface() { }
if (false) {
    /** @type {?} */
    B2cI18nInterface.prototype.locale;
    /** @type {?} */
    B2cI18nInterface.prototype.dateFormat;
    /** @type {?} */
    B2cI18nInterface.prototype.lang;
}

/**
 * @fileoverview added by tsickle
 * Generated from: locale/zh-Hans.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var zhHans = {
    locale: B2cLanguage.SIMPLIFIED_CN,
    dateFormat: B2cStandardDateFormat.CN,
    lang: {
        [I18nTransKey.LOGIN_TO_YOUR_ACCOUNT]: '登入您的账户',
        [I18nTransKey.SIGN_UP]: '开设账户',
        [I18nTransKey.OPEN_NEW_ACCOUNT]: '开设新的账户',
        [I18nTransKey.LOGIN_NAME]: '用户身份',
        [I18nTransKey.PASSWORD]: '密码',
        [I18nTransKey.REMEMBER_MY_USERNAME]: '记得用户名称',
        [I18nTransKey.LOGIN]: '登入',
        [I18nTransKey.FORGOT_USER_ID]: '忘记登入用户名称?',
        [I18nTransKey.FORGOT_PASSWORD]: '忘记登入密码?',
        [I18nTransKey.SIGN_UP_NOW]: '免费开设投资账户',
        [I18nTransKey.FOREIGN_CURRENCIES_UNITS]: '外国货币单位',
        [I18nTransKey.CHANGES]: '变化',
        [I18nTransKey.CURRENCY_AUD]: '1 澳元',
        [I18nTransKey.CURRENCY_CNY]: '1 人民币',
        [I18nTransKey.CURRENCY_EUR]: '1 欧元',
        [I18nTransKey.CURRENCY_GBP]: '1 英镑',
        [I18nTransKey.CURRENCY_MYR]: '1 马币',
        [I18nTransKey.CURRENCY_USD]: '1 美元',
        [I18nTransKey.SELECT_YOUR_COUNTRY]: '选择您的国家/地区',
        [I18nTransKey.FILTER]: '筛选',
        [I18nTransKey.CLEAR]: '重置',
        [I18nTransKey.SELECT_GEOGRAPHICAL_SECTOR]: '选择地理区域',
        [I18nTransKey.COUNTRY_AUD]: '澳大利亚',
        [I18nTransKey.COUNTRY_MYR]: '马来西亚',
        [I18nTransKey.COUNTRY_USD]: '美国',
        [I18nTransKey.COUNTRY_CNY]: '中国',
        [I18nTransKey.COUNTRY_GBP]: '英国',
        [I18nTransKey.COUNTRY_EUR]: '欧洲',
        [I18nTransKey.COUNTRY_IND]: '印度',
        [I18nTransKey.COUNTRY_SGD]: '新加坡',
        [I18nTransKey.COUNTRY_HK]: '香港',
        [I18nTransKey.DONE]: '完成',
        [I18nTransKey.SHARE]: '分享',
        [I18nTransKey.CANCEL]: '取消',
        [I18nTransKey.CLEAR_SELECTED_FILTER]: '清除选项',
        [I18nTransKey.TRANSACT]: '交易',
        [I18nTransKey.CURRENT_COUNTRY]: '所在地区',
        [I18nTransKey.SEARCH_PLACEHOLDER]: '搜索或输入产品名称',
        [I18nTransKey.SEARCH_NO_RESULT]: '没有记录',
        [I18nTransKey.SEARCHING]: '搜寻中',
        [I18nTransKey.SAFE_AREA_MESSAGE_1]: '为了保持最好的观看经验, 请刷新浏览器得以进入',
        [I18nTransKey.DESKTOP_VIEW]: '桌面视图。',
        [I18nTransKey.MOBILE_VIEW]: '移动视图。',
        [I18nTransKey.SAFE_AREA_MESSAGE_2]: '您所做的更改可能不会保存。',
        [I18nTransKey.CONTINUE_IN]: '继续浏览',
        [I18nTransKey.PROCEED_TO]: '前往',
        [I18nTransKey.WEBSITE]: '网站',
        [I18nTransKey.MOBILE_WEB]: '移动网站',
        [I18nTransKey.SECURITY_TIPS]: 'Tips to Online Security'
    }
};

/**
 * @fileoverview added by tsickle
 * Generated from: locale/zh-Hant-HK.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var zhHantHK = {
    locale: B2cLanguage.TRADITIONAL_CN_HK,
    dateFormat: B2cStandardDateFormat.CN
};

/**
 * @fileoverview added by tsickle
 * Generated from: locale/zh-Hant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var zhHant = {
    locale: B2cLanguage.TRADITIONAL_CN,
    dateFormat: B2cStandardDateFormat.CN
};

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-i18n.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CI18nPipe, B2C_LIB_I18N, B2cLanguage, B2cStandardDateFormat, I18nModule, I18nService, I18nTransKey, StandardDatePipe, en_US, zhHans as zh_Hans, zhHant as zh_Hant, zhHantHK as zh_Hant_HK };


//# sourceMappingURL=b2c-ui-i18n.js.map